import React, { useMemo, type FC } from "react";
import { MENU_LINK } from "~/src/utils/common";
import { useConnection } from "wagmi";
import AvacusLogoLink from "./AvacusLogoLink";
import { useAuthStore } from "../store/use-auth-store";

const AvacusLogoHeader: FC = () => {
  const isLoggedIn = useAuthStore((state) => state.isLoggedIn);
  const { address } = useConnection();

  const navigateLink = useMemo(() => {
    if (isLoggedIn && address) {
      return `${MENU_LINK.VIEW_PROFILE}/${address}`;
    }
    return MENU_LINK.LOGIN;
  }, [address, isLoggedIn]);

  return <AvacusLogoLink to={navigateLink} />;
};

export default AvacusLogoHeader;
